import React, { useState } from 'react';
import { Form } from 'formik';
import { withRouter, Link } from 'react-router-dom';
import {
  CardBody, CardHeader, CardTitle, Col, FormGroup, Card, Row, Button, UncontrolledTooltip, Input
} from 'reactstrap';
import XusomLogo from '../../../../assets/img/logo/xum-logo.png';
import { LoadCanvasTemplate } from 'react-simple-captcha';
import * as Icon from 'react-feather';
import TextField from '../../../../components/common/formElements/TextFieldFormik';
import ReactSelect from '../../../../components/common/formElements/ReactSelect';
import Radio from '../../../../components/common/formElements/RadioFormik';
import dropDownData from '../../../../constants/dropDownData';
import moment from 'moment';

const SignUpComp = (props) => {
  const [mask, setMask] = useState(true);
  const [newPasswordMask, setNewPasswordMask] = useState(true);
  const currentMonth = moment().month() + 1;
  const currentYear = moment().year();
  const [monthData, setMonthData] = useState(props.semesterDetails);
  const year = props.semester && props.semester.length > 0 && props.semester.map((x) => {
    return {
      name: x.year,
      id: x.id,
    };
  });

  const handleYearChange = (yearData) => {
    const year = yearData?.name;
    if (Number(year) === Number(currentYear)) {
      props.formProps.setFieldValue('semester', null);
      setMonthData(props.semesterDetails?.filter((x) => moment().month(x.name).format('M') > currentMonth));
    } else {
      setMonthData(props.semesterDetails);
    }
  };

  return (
    <Col sm="6" className="p-0 login mb-2 animate_card">
      <Form>
        <Card className="mb-0">
          <CardHeader className="mx-2">
            <CardTitle>
              Sign Up
            </CardTitle>
            <span className="ml-auto float-right">
              <Icon.ArrowLeft
                size={20}
                id="back"
                className="cursor-pointer "
                onClick={() => { props.history.push('/login'); }}
              />
              <UncontrolledTooltip placement="top" target="back">Back</UncontrolledTooltip>
            </span>
          </CardHeader>
          <CardBody>
            <img src={XusomLogo} alt="XusomLogo" className="d-block mx-auto xusom-logo mb-1" height="60" width="220" />
            <Row className="mx-0 justify-content-center">
              <Col md="6" sm="12">
                <FormGroup>
                  <TextField
                    name="firstName"
                    isAlphabetOnly
                    type="text"
                    isRequired
                    label="First Name"
                  />
                </FormGroup>
              </Col>
              <Col md="6" sm="12">
                <FormGroup>
                  <TextField
                    name="lastName"
                    isAlphabetOnly
                    type="text"
                    isRequired
                    label="Last Name"
                  />
                </FormGroup>
              </Col>
              <Col md="6" sm="12">
                <FormGroup>
                  <ReactSelect
                    label="Residence Country"
                    name="country"
                    options={props.country || []}
                    isRequired
                  />
                </FormGroup>
              </Col>
              <Col md="6" sm="12">
                <FormGroup>
                  <Row>
                    <Col sm="4">
                      <TextField
                        name="cellPhoneCode"
                        inputMasked
                        inputFormat="+9999"
                        type="text"
                        label="Country Code"
                      />
                    </Col>
                    <Col sm="8">
                      <TextField
                        name="cellPhone"
                        type="text"
                        label="Cell Phone"
                        placeholder="Cell Phone"
                        inputMasked
                        isRequired
                      />
                    </Col>
                  </Row>
                </FormGroup>
              </Col>
              <Col md="6" sm="12">
                <FormGroup>
                  <ReactSelect
                    label="Program"
                    name="program"
                    options={props.program || []}
                    isRequired
                  />
                </FormGroup>
              </Col>
              <Col md="6" sm="12">
                <FormGroup>
                  <ReactSelect
                    label="Semester Year"
                    name="semesterYear"
                    onChange={(e) => e && e.name && handleYearChange(e)}
                    options={year || []}
                    isRequired
                  />
                </FormGroup>
              </Col>
              <Col md="6" sm="12">
                <FormGroup>
                  <ReactSelect
                    label="Semester Month"
                    name="semester"
                    options={monthData || []}
                    isRequired
                  />
                </FormGroup>
              </Col>
              <Col md="6" sm="12">
                <FormGroup>
                  <TextField
                    name="email"
                    type="email"
                    label="Email"
                    isRequired
                  />
                </FormGroup>
              </Col>
              <Col sm="12" className="align-items-center d-flex mb-2">
                <Radio
                  externalLabel="Gender"
                  name="gender"
                  isRequired
                  options={dropDownData.GENDER}
                />
              </Col>
              <Col md="6" sm="12">
                <FormGroup>
                  <TextField
                    name="newPassword"
                    isRequired
                    label="Password"
                    type={mask ? 'password' : 'text'}
                    icon={<Icon.Eye size={16} className="cursor-pointer" onClick={() => setMask(!mask)} />}
                    rightIconDivider
                  />
                </FormGroup>
              </Col>
              <Col md="6" sm="12">
                <FormGroup>
                  <TextField
                    name="confirmPassword"
                    type={newPasswordMask ? 'password' : 'text'}
                    isRequired
                    label="Confirm Password"
                    icon={<Icon.Eye size={16} className="cursor-pointer" onClick={() => setNewPasswordMask(!newPasswordMask)} />}
                    rightIconDivider
                  />
                </FormGroup>
              </Col>
              <Col md="6" sm="12">
                <FormGroup className="text-center mb-1">
                  <LoadCanvasTemplate reloadText="Reload Captcha" reloadColor="red" />
                </FormGroup>
              </Col>
              <Col sm="6">
                <FormGroup>
                  <Input
                    name="user_captcha_input"
                    placeholder="Enter Capctha"
                    type="captcha"
                    value={props.captcha}
                    onChange={(e) => props.setCaptcha(e.target.value)}
                    onInput={() => props.setCaptchaError('')}
                    id="user_captcha"
                  />
                  <div className="text-danger">{props.captchaError}</div>
                </FormGroup>
              </Col>
            </Row>
            <Col className="d-flex justify-content-between mb-2">
              <Link to="/">
                <Button className="btn btn-success btnWidth-200" type="button">
                  Already user sign in here
                </Button>
              </Link>
              <Button
                className="btn btn-success btnWidth-200"
                type="submit"
                // onClick={() => {
                //   if (!props.captcha) {
                //     props.setCaptchaError('Captcha is required');
                //   }
                // }}
              >
                Sign Up
              </Button>
            </Col>
            <Col sm="12" className="d-flex justify-content-center py-1">
              <b className="text-danger">If trouble with application please email <a href="mailto:admissions@xusom.com" className="text-danger cursor-pointer textUnderline">admissions@xusom.com</a></b>
            </Col>
          </CardBody>
        </Card>
      </Form>
    </Col>
  );
};

export default withRouter(SignUpComp);
